import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { setRows, addRow, removeRow, removeSingleRow, updateRow } from '../../../Redux/actions/rowActions';
import { RxCross1 } from "react-icons/rx";
import AsyncSelect from 'react-select/async';

const StockAdjGrid = ({ onRequisitionData, itemData, selectedLocation, currencyPrecision }) => {
    const rows = useSelector(state => state.rows.rows);
    const dispatch = useDispatch();
    const [itemOptions, setItemOptions] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const apiService = new ApiService();
    const initialMount = useRef(true);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);

    useEffect(() => {
        if (selectedLocation && selectedLocation.label && rows[0].itemNo) {
            updateRowsWithNewStock();
        }
    }, [selectedLocation]);

    useEffect(() => {
        if (initialMount.current && itemData?.prDetails && itemData.prDetails.length > 0) {
            const fetchData = async () => {
                try {
                    const formattedRowsPromises = itemData?.prDetails.map(async (detail, index) => {
                        return {
                            requisitionNo: detail.requisitionNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            baseQty: 0,
                            convRate: detail.baseQty,
                            baseAmount: detail.unitPrice,
                            specification: detail.specification,
                            amount: detail.amount,
                            remarks: detail.remarks
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsPromises);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        onRequisitionData(formattedRows);
                    }
                } catch (error) {
                    console.error('Error handling input change:', error);
                }
            };
            fetchData();
        }
    }, [itemData, dispatch, onRequisitionData]);

    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            itemRows.forEach((row, index) => {
                dispatch(updateRow(index, row));
            });
        }
    }, [itemRows, dispatch]);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    useEffect(() => {
        onRequisitionData(rows);
    }, [rows])

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage(prevPage => prevPage + 1);
        await fetchItemNo("", page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc("", desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        try {
            debugger
            const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));

            if (isDuplicate) {
                toast.error('Please choose a different item.');
                return;
            }

            if (!selectedLocation || selectedLocation.length === 0) {
                toast.warning("Select Location")
                return;
            }
            const updatedRows = [...rows];
            const updatedRow = { ...updatedRows[index], [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };
            if (fieldName === 'itemNo' || fieldName === 'itemDescription') {
                const queryParam = fieldName === 'itemNo' ? `itemNo=${value}` : `ItemDescription=${value}`;
                const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${selectedLocation.label}&${queryParam}`);
                let selectedItem = selecteditmstock?.data?.result[0]
                if (selectedItem) {
                    updatedRow.itemDescription = selectedItem.itemDescription;
                    updatedRow.requisitionNo = selectedItem.itemDescription;
                    updatedRow.uom = selectedItem.unitMeasurement;
                    updatedRow.itemNo = selectedItem.itemNo;
                    updatedRow.specification = selectedItem.specification;
                    updatedRow.convRate = selectedItem.convToInvUOM;
                    updatedRow.baseQty = 0;
                    updatedRow.baseAmount = selectedItem?.avgPrice || 0;
                    updatedRow.stock = selectedItem?.stock || 0;
                }
            }
            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                const stock = updatedRow.stock;
                if (quantity > stock) {
                    toast.warning('Enter a quantity less than or equal to the Stock.');
                    return
                }
                const baseQty = 1;
                updatedRow.baseQty = (!isNaN(quantity) && quantity !== 0) ? (quantity * baseQty) : 0;
            }
            if (fieldName === 'qty' || fieldName === 'baseAmount') {
                const quantity = parseFloat(updatedRow.qty);
                const stock = updatedRow.stock;
                if (quantity > stock) {
                    toast.warning('Enter a quantity less than or equal to the Stock.');
                    return
                }
                const unitPrice = parseFloat(updatedRow.baseAmount);
                updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(currencyPrecision || 0) : 0;
            }
            if (fieldName === 'remarks') {
                updatedRow.remarks = value;
            }
            updatedRows[index] = updatedRow;
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    }
    const addNewRow = () => {
        const newRow = {
            srno: '',
            itemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            convRate: '',
            baseAmount: '',
            amount: '',
            stock: '',
            remarks: '',
            recordId: '',
            specification: '',
            remarks: ''
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows)); // Ensure Redux state is updated here
    }
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));

    }
    const updateRowsWithNewStock = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.itemNo}`;
                const response = await apiService.getApiParamater(
                    'GET_ITEM_STORE',
                    `?Warehouse=${selectedLocation.label}&${queryParam}`
                );
                if (response?.data?.statusCode === 200) {
                    const itemData = response.data.result[0];
                    updatedRows[index].stock = itemData.stock || 0;
                    updatedRows[index].stockType = itemData.stockType || "---";
                    updatedRows[index].itemDescription = itemData.itemDescription;
                    updatedRows[index].uom = itemData.baseUnit;
                    updatedRows[index].baseQty = parseFloat(itemData.convToInvUOM);
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            dispatch(setRows([...updatedRows]));
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th></th>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Inventory Qty</th>
                        <th>Inventory UOM</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                        <th>Stock</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(itemRows) && rows?.map((row, index) => (
                        <tr key={index}>
                            {itemData?.eye ?
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", cursor: "not-allowed" }}>
                                    <div className='center'>
                                        <RxCross1 size={25} disabled />
                                    </div>
                                </td> :
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}>
                                    <div onClick={() => handleRemoveRow(index)} className='center'>
                                        <RxCross1 size={25} />
                                    </div>
                                </td>
                            }
                            <td className='m-0 p-0'><input className='p-2' type="text" style={{ width: "80px" }} value={row.srno} disabled /></td>
                            <td className='m-0 p-0'>
                                {itemData?.eye ?
                                    <input className='p-2' type='text' disabled value={row?.itemNo} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemNo, label: row.itemNo }}
                                        options={itemOptions}
                                        loadOptions={loadOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemNo', selectedOption.label)}
                                        defaultOptions={itemOptions}
                                        onMenuScrollToBottom={loadMoreOptions}
                                    />
                                }
                            </td>
                            <td className='m-0 p-0'>
                                {itemData?.eye ?
                                    <input className='p-2' disabled value={row.itemDescription} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemDescription, label: row.itemDescription }}
                                        options={descriptionOptions}
                                        loadOptions={loadDescOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                        className="w-100 p-0"
                                        defaultOptions={descriptionOptions}
                                        onMenuScrollToBottom={loadMoreDescOptions}
                                    />
                                }
                            </td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' style={{ width: "130px" }} type="text" value={row.specification} onChange={e => handleInputChange(index, 'specification', e.target.value)} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' type="number" value={row.qty} style={{ width: "130px" }} onChange={e => handleInputChange(index, 'qty', e.target.value)} /></td>
                            }
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.baseAmount)?.toFixed(currencyPrecision)} style={{ width: "130px" }} /></td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount)?.toFixed(currencyPrecision)} style={{ width: "120px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "120px" }} value={row.amount} onChange={e => handleInputChange(index, 'amount', e.target.value)} /></td>
                            }
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.stock)?.toFixed(2)} style={{ width: "100px" }} /></td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.remarks} style={{ width: "130px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.remarks} style={{ width: "130px" }} onChange={e => handleInputChange(index, 'remarks', e.target.value)} /></td>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            {itemData?.eye ? "" :
                <div className='row mt-5'>
                    <div className='col-2'>
                        <button className='mainbtn ' onClick={addNewRow}>
                            Add Item
                        </button>
                    </div>
                    {/* <div className=' col-2'>
                        <button className='mainbtn ' onClick={removeLastRow}>
                            Remove
                        </button>
                    </div> */}
                </div>
            }
        </div>
    );
};

export default StockAdjGrid;
